import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import Toggle from '../../../Common/Toggle/Toggle';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const UnidadeMedida = () => {
  const [unidades, setUnidades] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    unidade_medida: '',
    sigla: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarUnidades = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/unidades-medida`);

      if (!response.ok) {
        throw new Error('Erro ao buscar unidades de medida');
      }

      const data = await response.json();

      const formatadas = data.map((item) => ({
        id: item.id_unidade_medida,
        unidade_medida: item.nome_unidade_medida,
        sigla: item.sigla_unidade_medida,
        ativo: item.ativo
      }));

      setUnidades(formatadas);
    } catch (error) {
      console.error('Erro ao carregar unidades de medida:', error);
      alert(
        'Erro ao carregar unidades de medida. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarUnidades();
  }, []);

  const filteredUnidades = unidades.filter((unidade) =>
    unidade.unidade_medida?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    unidade.sigla?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        nome_unidade_medida: formData.unidade_medida,
        sigla_unidade_medida: formData.sigla,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/unidades-medida/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar unidade de medida');
        }

        const atualizado = await response.json();

        setUnidades((prev) =>
          prev.map((unidade) =>
            unidade.id === editingId
              ? {
                  id: atualizado.id_unidade_medida,
                  unidade_medida: atualizado.nome_unidade_medida,
                  sigla: atualizado.sigla_unidade_medida,
                  ativo: atualizado.ativo
                }
              : unidade
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/unidades-medida`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar unidade de medida');
        }

        const criado = await response.json();

        setUnidades((prev) => [
          ...prev,
          {
            id: criado.id_unidade_medida,
            unidade_medida: criado.nome_unidade_medida,
            sigla: criado.sigla_unidade_medida,
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar unidade de medida:', error);
      alert(
        'Erro ao salvar unidade de medida. Verifique os dados e tente novamente.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (unidade) => {
    setFormData({
      unidade_medida: unidade.unidade_medida,
      sigla: unidade.sigla,
      ativo: unidade.ativo
    });
    setEditingId(unidade.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        'Tem certeza que deseja excluir esta unidade de medida?'
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/unidades-medida/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir unidade de medida');
      }

      setUnidades((prev) => prev.filter((unidade) => unidade.id !== id));
    } catch (error) {
      console.error('Erro ao excluir unidade de medida:', error);
      alert('Erro ao excluir unidade de medida. Tente novamente.');
    }
  };

  const handleToggleStatus = async (id) => {
    const unidadeSelecionada = unidades.find((u) => u.id === id);

    if (!unidadeSelecionada) {
      return;
    }

    const novoAtivo = !unidadeSelecionada.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/unidades-medida/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_unidade_medida: unidadeSelecionada.unidade_medida,
            sigla_unidade_medida: unidadeSelecionada.sigla,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da unidade de medida');
      }

      const atualizado = await response.json();

      setUnidades((prev) =>
        prev.map((unidade) =>
          unidade.id === id
            ? { ...unidade, ativo: atualizado.ativo }
            : unidade
        )
      );
    } catch (error) {
      console.error(
        'Erro ao atualizar status da unidade de medida:',
        error
      );
      alert(
        'Erro ao atualizar status da unidade de medida. Tente novamente.'
      );
    }
  };

  const resetForm = () => {
    setFormData({ unidade_medida: '', sigla: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Unidades de Medida</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Unidade de Medida' : 'Cadastrar Unidade de Medida'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="unidade_medida">Unidade de Medida *</label>
              <input
                type="text"
                id="unidade_medida"
                value={formData.unidade_medida}
                onChange={(e) => setFormData({...formData, unidade_medida: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite a unidade de medida"
              />
            </div>

            <div className="form-group">
              <label htmlFor="sigla">Sigla *</label>
              <input
                type="text"
                id="sigla"
                value={formData.sigla}
                onChange={(e) => setFormData({...formData, sigla: e.target.value})}
                required
                maxLength={20}
                placeholder="Digite a sigla"
              />
            </div>

            <div className="form-group">
              <Toggle
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({ ...formData, ativo: e.target.checked })}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : (editingId ? 'Atualizar' : 'Cadastrar')}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar unidades de medida..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredUnidades.length} registro(s) encontrado(s)</span>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Cadastrar Unidade
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Unidade de Medida</th>
                  <th className="col-sigla">Sigla</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredUnidades.map(unidade => (
                  <tr key={unidade.id}>
                    <td className="col-id">{unidade.id}</td>
                    <td className="col-nome">{unidade.unidade_medida}</td>
                    <td className="col-sigla">
                      <span className="sigla-badge">{unidade.sigla}</span>
                    </td>
                    <td className="col-status">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          id={`toggle-${unidade.id}`}
                          checked={unidade.ativo}
                          onChange={() => handleToggleStatus(unidade.id)}
                        />
                      </div>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(unidade)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(unidade.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredUnidades.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhuma unidade de medida encontrada</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova unidade.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UnidadeMedida;
